import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "tri-submenu" }
const _hoisted_2 = { class: "tri-submenu__title" }

import type { RouteRecordRaw } from 'vue-router'
import { TriMenus } from '@tri-admin/layout'


export default /*#__PURE__*/_defineComponent({
  __name: 'SubmenuList',
  props: {
    data: {},
    active: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h3", _hoisted_2, [
      _createElementVNode("em", null, _toDisplayString((_ctx.data.meta && _ctx.data.meta.title) || ''), 1)
    ]),
    _createVNode(_unref(TriMenus), {
      class: "tri-submenu__panel",
      data: _ctx.data.children,
      active: _ctx.active
    }, null, 8, ["data", "active"])
  ]))
}
}

})